import React, { useEffect, useState } from 'react';

const Filter = ({ onFilterChange }) => {
  const [projects, setProjects] = useState([]);
  const [collections, setCollections] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [category, setCategory] = useState([]);
  const [subcategory, setSubcategory] = useState([]);
  const [mediatypes, setMediatypes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [creator, setCreator] = useState([]);
  const [recorder, setRecorder] = useState([]);
  
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedCollection, setSelectedCollection] = useState('');
  const [selectedKeyword, setSelectedKeyword] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubcategory, setSelectedSubcategory] = useState('');
  const [selectedMediatype, setSelectedMediatype] = useState('');
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedCreator, setSelectedCreator] = useState('');
  const [selectedRecorder, setSelectedRecorder] = useState('');

  useEffect(() => {
    fetchProjects();
    fetchCollections();
    fetchKeywords();
    fetchCategory();
    fetchSubcategory();
    fetchMediatypes();
    fetchCountries();
    fetchCities();
    fetchCreator();
    fetchRecorder();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await fetch(`/api/projects`);
      const jsonData = await response.json();
      setProjects(jsonData);
    } catch (err) {
      console.error("Error fetching projects:", err);
    }
  };

  const fetchCollections = async () => {
    try {
      const response = await fetch(`/api/collections`);
      const jsonData = await response.json();
      setCollections(jsonData);
    } catch (err) {
      console.error("Error fetching collections:", err);
    }
  };

  const fetchKeywords = async () => {
    try {
      const response = await fetch(`/api/keywords`);
      const jsonData = await response.json();
      setKeywords(jsonData);
    } catch (err) {
      console.error("Error fetching keywords:", err);
    }
  };

  const fetchCategory = async () => {
    try {
      const response = await fetch(`/api/category`);
      const jsonData = await response.json();
      setCategory(jsonData);
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };

  const fetchSubcategory = async () => {
    try {
      const response = await fetch(`/api/subcategory`);
      const jsonData = await response.json();
      setSubcategory(jsonData);
    } catch (err) {
      console.error("Error fetching subcategory:", err);
    }
  };

  const fetchMediatypes = async () => {
    try {
      const response = await fetch(`/api/medtypes`);
      const jsonData = await response.json();
      setMediatypes(jsonData);
    } catch (err) {
      console.error("Error fetching media types:", err);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await fetch(`/api/countries`);
      const jsonData = await response.json();
      setCountries(jsonData);
    } catch (err) {
      console.error("Error fetching countries:", err);
    }
  };

  const fetchCities = async () => {
    try {
      const response = await fetch(`/api/cities`);
      const jsonData = await response.json();
      setCities(jsonData);
    } catch (err) {
      console.error("Error fetching cities:", err);
    }
  };
  const fetchCreator = async () => {
    try {
      const response = await fetch(`/api/people`);
      const jsonData = await response.json();
      setCreator(jsonData);
    } catch (err) {
      console.error("Error fetching people creator:", err);
    }
  };
  const fetchRecorder = async () => {
    try {
      const response = await fetch(`/api/people`);
      const jsonData = await response.json();
      setRecorder(jsonData);
    } catch (err) {
      console.error("Error fetching people recorder:", err);
    }
  };

  
  const handleProjectChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedProject(selectedValue);
    onFilterChange(selectedValue, selectedCollection, selectedKeyword, selectedCategory, selectedSubcategory, selectedMediatype, selectedCountry, selectedCity, selectedCreator, selectedRecorder);  
  };

  const handleCollectionChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedCollection(selectedValue);
    onFilterChange(selectedProject, selectedValue, selectedKeyword, selectedCategory, selectedSubcategory, selectedMediatype, selectedCountry, selectedCity, selectedCreator, selectedRecorder);  
  };

  const handleKeywordChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedKeyword(selectedValue);
    onFilterChange(selectedProject, selectedCollection, selectedValue, selectedCategory, selectedSubcategory, selectedMediatype, selectedCountry, selectedCity, selectedCreator, selectedRecorder);  
  };

  const handleCategoryChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedCategory(selectedValue);
    onFilterChange(selectedProject, selectedCollection, selectedKeyword, selectedValue, selectedSubcategory, selectedMediatype, selectedCountry, selectedCity, selectedCreator, selectedRecorder);  
  };

  const handleSubcategoryChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedSubcategory(selectedValue);
    onFilterChange(selectedProject, selectedCollection, selectedKeyword, selectedCategory, selectedValue, selectedMediatype, selectedCountry, selectedCity, selectedCreator, selectedRecorder);  
  };

  const handleMediatypeChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedMediatype(selectedValue);
    onFilterChange(selectedProject, selectedCollection, selectedKeyword, selectedCategory, selectedSubcategory, selectedValue, selectedCountry, selectedCity, selectedCreator, selectedRecorder);  
  };

  const handleCountryChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedCountry(selectedValue);
    onFilterChange(selectedProject, selectedCollection, selectedKeyword, selectedCategory, selectedSubcategory, selectedMediatype, selectedValue, selectedCity, selectedCreator, selectedRecorder);  
  };

  const handleCityChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedCity(selectedValue);
    onFilterChange(selectedProject, selectedCollection, selectedKeyword, selectedCategory, selectedSubcategory, selectedMediatype, selectedCountry, selectedValue, selectedCreator, selectedRecorder);  
  };

  const handleCreatorChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedCreator(selectedValue);
    onFilterChange(selectedProject, selectedCollection, selectedKeyword, selectedCategory, selectedSubcategory, selectedMediatype, selectedCountry, selectedCity, selectedValue, selectedRecorder);  
  };

  const handleRecorderChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedRecorder(selectedValue);
    onFilterChange(selectedProject, selectedCollection, selectedKeyword, selectedCategory, selectedSubcategory, selectedMediatype, selectedCountry, selectedCity, selectedCreator, selectedValue);  
  };

  const closeFilterOnSelection = () => {
    const filterSpace = document.querySelector('.filter_space');
    if (filterSpace.classList.contains('open')) {
      filterSpace.classList.remove('open');
    }
  };



  return (
  <div className="filter_space">
      <h3>Filter</h3>
      <button className="close-filter" onClick={closeFilterOnSelection}>
          Close
      </button>
    <div className='filter_content'>
      <div>
      <h5>Projects</h5>
        <select value={selectedProject} onChange={handleProjectChange}>
          <option value="">All Projects</option>
          {projects.map((project, index) => (
            <option key={index} value={project.prj_name}>
              {project.prj_name}
            </option>
          ))}
        </select>
      </div>
      <div>
      <h5>Collections</h5>
        <select value={selectedCollection} onChange={handleCollectionChange}>
          <option value="">All Collections</option>
          {collections.map((collection, index) => (
            <option key={index} value={collection.col_name}>
              {collection.col_name}
            </option>
          ))}
        </select>
      </div>
      <div>
      <h5>Keywords</h5>
        <select value={selectedKeyword} onChange={handleKeywordChange}>
          
          <option value="">All Keywords</option>
          {keywords.map((keyword, index) => (
            <option key={index} value={keyword.key_name}>
              {keyword.key_name}
            </option>
          ))}
        </select>
      </div>
      <div>
      <h5>Categories</h5>
        <select value={selectedCategory} onChange={handleCategoryChange}>
          
          <option value="">All Categories</option>
          {category.map((category, index) => (
            <option key={index} value={category.cat_name}>
              {category.cat_name}
            </option>
          ))}
        </select>
      </div>
      <div>
      <h5>Subcategories</h5>
        <select value={selectedSubcategory} onChange={handleSubcategoryChange}>
          
          <option value="">All Subcategories</option>
          {subcategory.map((subcategory, index) => (
            <option key={index} value={subcategory.subcat_name}>
              {subcategory.subcat_name}
            </option>
          ))}
        </select>
      </div>
      <div>
      <h5>Media Types</h5>
        <select value={selectedMediatype} onChange={handleMediatypeChange}>
          
          <option value="">All Media Types</option>
          {mediatypes.map((mediatype, index) => (
            <option key={index} value={mediatype.med_name}>
              {mediatype.med_name}
            </option>
          ))}
        </select>
      </div>
      <div>
      <h5>Countries</h5>
        <select value={selectedCountry} onChange={handleCountryChange}>
          
          <option value="">All Countries</option>
          {countries.map((country, index) => (
            <option key={index} value={country.cont_name}>
              {country.cont_name}
            </option>
          ))}
        </select>
      </div>
      <div>
      <h5>Cities</h5>
        <select value={selectedCity} onChange={handleCityChange}>
          
          <option value="">All Cities</option>
          {cities.map((city, index) => (
            <option key={index} value={city.city_name}>
              {city.city_name}
            </option>
          ))}
        </select>
      </div>
      <div>
      <h5>Creator</h5>
        <select value={selectedCreator} onChange={handleCreatorChange}>
        <option value="">All Creators</option>
        {creator.map((creator, index) => (
          <option key={index} value={recorder.pers_name || recorder.pers_nick}>
            {creator.pers_nick || creator.pers_name}
          </option>
        ))}
        </select>
      </div>
      <div>
      <h5>Recorder</h5>
        <select value={selectedRecorder} onChange={handleRecorderChange}>
        <option value="">All Recorders</option>
{recorder.map((recorder, index) => (
  <option key={index} value={creator.pers_name || creator.pers_nick}>
    {recorder.pers_nick || recorder.pers_name}
  </option>
))}
        </select>
      </div>
    </div>
  </div>
  );
};


export default Filter;
